import * as React from 'react'
import { NextButton } from '../../../../shared/components/Button'
import { Text } from '../../../../shared/components/Elements'
import { HeadlineCSS } from '../../../../shared/components/Headlines'
import { breakpoint, styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'

interface IProps {
  title: string
  recommended?: boolean
  onNextClick?: () => void
  imageName?: string
}

export class MaterialContent extends React.Component<IProps> {
  render (): React.ReactNode {
    const { title, recommended, children, imageName } = this.props
    return (<Container>
      <Left>
        <img src={Utils.getAssetPath('/assets/calculator/material_' + imageName + '.png')} />
      </Left>
      <Right>
        <MaterialHeadline>
          {title}
          {recommended && <RecommendedHeadline>Empfohlen!</RecommendedHeadline>}
        </MaterialHeadline>

        <MaterialText>{children}</MaterialText>

        <NextButton primary onClick={this.props.onNextClick}>Auswählen & Weiter</NextButton>
      </Right>
    </Container>)
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  ${breakpoint('tablet')`
    flex-direction: row;
    padding: 40px;
  `}
`

const Left = styled.div`
  flex: 0 0 350px;
`

const Right = styled.div``

const MaterialHeadline = styled.h3`
  ${HeadlineCSS};
  font-size: 20px !important;
  margin-bottom: 1em;
`

const RecommendedHeadline = styled.span`
  ${HeadlineCSS};
  font-size: 20px !important; 
  text-decoration: underline;
  color: ${props => props.theme.primaryColor};
  margin-left: 25px;
`

const MaterialText = styled(Text)`
  margin-bottom: 2em;  
`
